import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PublicationRoutingModule } from './publication-routing.module';
import { PublicationComponent } from './publication.component';
import { PageViewerComponent } from './page-viewer/page-viewer.component';
import { ShowAllinOnePageComponent } from './show-allin-one-page/show-allin-one-page.component';
import { ParagraphActionMenuComponent } from './shared-components/paragraph-action-menu/paragraph-action-menu.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTreeModule } from '@angular/material/tree';
import { SharedModule } from 'src/app/common/shared.module';
import { BreadcrumbsPathComponent } from './shared-components/breadcrumbs-path/breadcrumbs-path.component';
import { TableOfContentComponent } from './shared-components/table-of-content/table-of-content.component';



@NgModule({
  declarations: [
    PublicationComponent,
    PageViewerComponent,
    ParagraphActionMenuComponent,
    BreadcrumbsPathComponent,
    ShowAllinOnePageComponent, TableOfContentComponent
  ],
  providers: [],
  imports: [
    SharedModule,
    CommonModule, MatTreeModule,
    PublicationRoutingModule, MatIconModule, MatButtonModule, MatMenuModule, MatSlideToggleModule, MatBadgeModule, MatTableModule, MatSortModule, MatPaginatorModule
  ],
  exports: [BreadcrumbsPathComponent]

})
export class PublicationModule { }
